import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { HttpClient } from '@angular/common/http';

import { TitleService } from '@core/services/title.service';

import { User } from '@core/objects/user';
import { Version } from '@core/objects/version';

import { VersionFeedback } from '@core/models/version-feedback';

import { Session } from '@app/store/models/session.model';
import { AppService } from '@app/services/app/app.service';

export interface ExtendedVersionFeedback extends VersionFeedback {
    share: any;
    entry: any;
}
/**
 * @deprecated jan-2023: component not used in ShareFeedbackAppRouterModule since 
 *  internal share review could be done in version detials. 
 *  TODO: Review components used here.
 */

@Component({
    selector: 'plugin-share-feedback-main-review',
    templateUrl: './main-review.component.html',
    styleUrls: ['./main-review.component.scss']
})
// Dec-2022: This component will be deprecated after version approval screen update
export class PluginShareFeedbackReviewMainAppComponent implements OnInit {

    public readonly LOADING = 0;
    public readonly DONE = 1;
    public readonly NOT_FOUND = 3;

    public status: number = this.LOADING;
    // public entry: any = null;

    public feedbacks: Array<ExtendedVersionFeedback> = [];
    public feedbackSelected: ExtendedVersionFeedback;

    protected userId: string;
    protected versionId: string;

    protected currentUser: User = null;

    constructor(private appSrv: AppService, private http: HttpClient, private activeRoute: ActivatedRoute, private title: TitleService) {}

    ngOnInit() {
        //this.bubbles = true; // TODO manage to HIDE bubbles
        this.title.set("Feedback review");

        // get data from url
        this.userId = this.activeRoute.snapshot.paramMap.get('user');
        this.versionId = this.activeRoute.snapshot.paramMap.get('vid');

        if(this.versionId == null || this.userId == null) {
            this.status = this.NOT_FOUND;
            return;
        }

        this.appSrv.getSession().subscribe( (session: Session) => {
            this.currentUser = session.current.user;
        });

        this.loadFeedbacks();

    }

    protected loadFeedbacks() {
        this.http.get("/web/app/p/feedback/versions/"+this.versionId+"/users/"+this.userId).subscribe(
            (data:any) => {
                if(data.length == 0) {
                    this.status = this.NOT_FOUND;
                    return;
                }

                this.feedbacks = data;
                let currentFeedback = data.filter( f => f.version.id.toString() == this.versionId);

                if(currentFeedback.length > 0) {
                    let feedback = currentFeedback[0];
                    if(this.currentUser.id != feedback.user.id) {
                        this.feedbackSelected = feedback;
                        this.status = this.DONE;
                    } else
                        this.redirectToPublic(feedback);
                }
                else
                    this.status = this.NOT_FOUND;
               
            },
            (error:any) => {
                this.status = this.NOT_FOUND;
            }
        );
    }

    protected redirectToPublic(feedback: ExtendedVersionFeedback) {
        let hash = feedback.share.entry.hash;
        let idVersion = feedback.version.id;
        window.location.href = '/share/p/feedback/' + hash +'/' + idVersion;
    }

    // click on left menu version
    protected onClickVersion(version: Version) {
        console.debug(" selecting version ",version.id);
        //this.versionSelected = version;
        this.status = this.LOADING;

        let currentFeedback = this.feedbacks.filter( f => f.version.id == version.id);

        if(currentFeedback.length > 0) {
            this.feedbackSelected = null;
            // console.debug(" current updated feedback ",currentFeedback[0]);
            this.feedbackSelected = currentFeedback[0];
            this.status = this.DONE;
        }
        else
            this.status = this.NOT_FOUND;
    }

}
